module.exports = __webpack_public_path__ + "img/item9.b8c2f593.png";